import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

export default function Educational() {
  return (
    <div className="min-h-screen px-6 py-12 bg-[#0d0d1a] text-[#e0f7fa]">
      <Helmet>
        <title>Educational Browser Games for Kids - BrowserArena</title>
        <meta
          name="description"
          content="Discover fun and interactive educational browser games for kids that enhance learning in math, reading, problem-solving, and more."
        />
      </Helmet>

      <div className="max-w-4xl mx-auto rounded-2xl border border-[#00f0ff] bg-[#111122]/80 shadow-xl shadow-[#00f0ff]/10 backdrop-blur-lg p-8">
        <h1 className="text-4xl font-bold text-[#00f0ff] mb-6 tracking-wide">
          Educational Browser Games for Kids
        </h1>

        <p className="text-lg leading-relaxed mb-6">
          Browser-based educational games have become an essential tool in modern learning environments. Designed to be both fun and informative, these games help children improve skills in math, reading, problem-solving, and more—without feeling like a chore.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          These games seamlessly blend gameplay with learning objectives. Puzzle games strengthen logic, word games expand vocabulary, and science or geography games spark curiosity about the world.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          Trusted by parents and teachers, our games are accessible on desktops, tablets, and mobile devices—perfect for classrooms or home learning.
        </p>

        <p className="text-lg leading-relaxed mb-6">
          At <strong>BrowserArena</strong>, we handpick educational games that are safe, visually engaging, and aligned with real academic goals. From spelling bees to math puzzles, we aim to make learning playful.
        </p>

        <div className="mt-8 text-center">
          <p className="text-base mb-4">
            Learn more about{" "}
            <Link to="/about-browser-games" className="text-[#00f0ff] underline hover:text-[#ff007f] transition">
              browser games
            </Link>{" "}
            or explore our{" "}
            <Link to="/html5-games" className="text-[#00f0ff] underline hover:text-[#ff007f] transition">
              HTML5 games
            </Link>{" "}
            collection now.
          </p>

          {/* <Link
            to="/educational-games" // You can create this route later
            className="inline-block mt-4 px-6 py-2 text-base font-semibold rounded-full border border-[#00f0ff] text-[#00f0ff] hover:bg-[#00f0ff]/10 hover:text-[#ff007f] transition"
          >
            🧠 Coming Soon: Educational Games Section
          </Link> */}
        </div>
      </div>
    </div>
  );
}
